import actions from './actions';
import { createReducer } from '../../../../helpers/reducer';

const initState = {
  loading: false,
  positions: null,
  total: 0,
  filters: null,
};

function onLoad(state) {
  return { ...state, loading: true, isEdit: false };
}

function onLoadSuccess(state, { payload }) {
  const { data, total, filteredTotal, filters } = payload;

  return { ...state, positions: data, total, filteredTotal, filters, loading: false };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.CLEAR_STORE]: onClearStore,
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
});
